import { render, staticRenderFns } from "./StatsItem.vue?vue&type=template&id=0d4838ac&scoped=true&"
import script from "./StatsItem.vue?vue&type=script&lang=js&"
export * from "./StatsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4838ac",
  null
  
)

export default component.exports